import { ofType } from 'redux-observable';
import { map, switchMap } from 'rxjs/operators';
import JobProApi from '../../dependencies/JobProApi';

const CREW_FIELDS = 'id,deliveryCrew,equipment(id,color,displayOrder,name,workCapacities(capacityType,value),officeRef(id,name)),installationCrew,office(id,name),resources(resource(id,firstName,lastName,offices(id)),resourcePercentage)';

// Action types
const FETCH_STANDARD_CREWS = 'FETCH_STANDARD_CREWS';
export const FETCH_STANDARD_CREWS_COMPLETE = 'FETCH_STANDARD_CREWS_COMPLETE';

const DEFAULT_STATE = {
  crews: [],
  loading: false
};

// Reducer
export default function (state = DEFAULT_STATE, { payload, type }) {
  switch (type) {
    case FETCH_STANDARD_CREWS:
      return  DEFAULT_STATE;
    case FETCH_STANDARD_CREWS_COMPLETE:
      return {
        ...state,
        ...payload,
        loading: false
      }
    default:
      return state;
  }
}

// Action creators
export const fetchStandardCrews = () => ({
  type: FETCH_STANDARD_CREWS
});

const fetchStandardCrewsComplete = (crews) => ({
  type: FETCH_STANDARD_CREWS_COMPLETE,
  payload: { crews }
});

// Epics
export const fetchStandardCrewsEpic = (action$) => action$.pipe(
  ofType(FETCH_STANDARD_CREWS),
  switchMap(() => JobProApi.standardCrews.query({
    fields: CREW_FIELDS
  })),
  map(fetchStandardCrewsComplete),
);

// Selectors
export * from './selectors';
